export default __webpack_public_path__ + "static/media/1.27ca1b35.jpg";